<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>

import VueTypes from "vue-types";

import {DiscoveryMode} from "@/modules/redactor/models/discovery/DiscoveryMode";

export default {
  name: "r-discovery-mode",
  props: {
    model: VueTypes.instanceOf(DiscoveryMode),
    label: VueTypes.string.def("Mode:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return DiscoveryMode.getValues();
    }
  }
}
</script>